import React from "react";
import CTE from "../Constants";
import ChatOptions from "../ChatOptions/ChatOptions";
function ChatWidgetOutside(props) {
    switch (props.message.contentType) {
        case CTE.CONTENT_TYPE.OPTIONS:
            if (props.message.widgetOptions && props.message.widgetOptions.showInChat) {
                return (
                    <ChatOptions
                        options={props.message.options}
                        selectOptionCb={
                            props.interactionCb
                                ? props.interactionCb
                                : () => console.log("Option selected")
                        }
                    />
                );
            } else {
                return null;
            }
        default:
            return null;
    }
}
export default ChatWidgetOutside;
